import React from "react";
import { Link } from "react-router-dom";

// The organizations Cloud Print works with, in a band under the home page's hero,
// ending with the way for another one to join (/partners).
// A new one is a logo in public/assets/img/partners/ and a line here; width and
// height are the file's own, to keep its shape before it loads.
const PARTNERS = [
  { name: "CU", logo: "/assets/img/partners/cu.svg", width: 340, height: 212 },
  { name: "Canon", logo: "/assets/img/partners/canon.svg", width: 800, height: 360 },
];

const Partners = () => (
  <section className="home-partners" aria-labelledby="home-partners-title">
    <div className="container home-partners-inner">
      <h2 id="home-partners-title" className="home-partners-title">
        Хамтрагч байгууллага
      </h2>
      <ul className="home-partners-list">
        {PARTNERS.map((partner) => (
          <li key={partner.name}>
            <img
              src={partner.logo}
              width={partner.width}
              height={partner.height}
              loading="lazy"
              alt={partner.name}
            />
          </li>
        ))}
      </ul>
      <Link to="/partners" className="home-partners-join">
        Хамтран ажиллах <i className="fas fa-arrow-right" aria-hidden="true"></i>
      </Link>
    </div>
  </section>
);

export default Partners;
